export const SHOWCASE_STORIES_FEATURE_NAME = 'showcaseStories';
